import { render, staticRenderFns } from "./DocumentClaim.vue?vue&type=template&id=ae4767ae&"
import script from "./DocumentClaim.vue?vue&type=script&lang=js&"
export * from "./DocumentClaim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports